import React from 'react';

export interface HeaderSearchTriggerProps {
    onClick: () => void;
    /** Muestra el texto "Buscador" junto al ícono. úsalo en la instancia de desktop. */
    showLabel?: boolean;
    className?: string;
}

const triggerStyle: React.CSSProperties = {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
};

const iconStyle: React.CSSProperties = {
    color: '#ffffff',
    fontSize: '20px',
};

const labelStyle: React.CSSProperties = {
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '16px',
    whiteSpace: 'nowrap',
};

/** Botón que abre el buscador del header. */
const HeaderSearchTrigger = ({
    onClick,
    showLabel = false,
    className = '',
}: HeaderSearchTriggerProps) => (
    <button
        type="button"
        onClick={onClick}
        aria-label="Abrir buscador"
        style={triggerStyle}
        className={className}
    >
        <i className="icon-Search" style={iconStyle}></i>
        {showLabel && <span style={labelStyle}>Buscador</span>}
    </button>
);

export default HeaderSearchTrigger;
